import { getType } from 'typesafe-actions';
import { SpotifyPlaylist } from '../types';
import { spotifyFetchPlaylistTracks } from '../actions';

export const fetchPlaylistTrackSuccessPattern =
  (playlistId: SpotifyPlaylist['id']) =>
  ({ type, payload }: any) => // eslint-disable-line
    type === getType(spotifyFetchPlaylistTracks.success) &&
    payload.playlistId === playlistId;
